import { formatInTimeZone } from 'date-fns-tz'

interface ISetDateOptions {
    year?: number
    month?: number
    day?: number
    hours?: number
    minutes?: number
    seconds?: number
    ms?: number
}

export function formatDate(data: Date, formatDefault = 'dd/MM/yyyy HH:mm', timeZoneDefault = 'America/Sao_Paulo'): string {
    return formatInTimeZone(new Date(data), timeZoneDefault, formatDefault)
}

export function setDate(date: Date, options: ISetDateOptions): Date {
    let d = date
    if (options.year) {
        d = new Date(d.setFullYear(options.year))
    }
    if (options.month) {
        d = new Date(d.setMonth(options.month))
    }
    if (options.day) {
        d = new Date(d.setDate(options.day))
    }
    return d
}
